<script setup lang="ts">
import { create } from "domain";
import { inject, ref, onMounted } from "vue";

const { tabs } = defineProps({
    tabs: {
        type: Array,
        required: true,
    },
});

const currentTab = ref(0);

onMounted(() => {});
</script>
<template>
    <div>
        <div class="tabs flex gap-14 px-6">
            <button
                v-for="(tab, index) in tabs"
                :key="index"
                class="border-b-4 border-transparent pb-2 text-f5"
                :class="[
                    'tab',
                    currentTab === index
                        ? 'tab-active font-bold border-b-primary'
                        : '',
                ]"
                @click="currentTab = index"
            >
                {{ tab.title }}
            </button>
        </div>
        <div class="tab-content">
            <div
                v-for="(tab, index) in tabs"
                :key="index"
                v-show="currentTab === index"
                class="bg-white rounded-md shadow pl-8 px-12 py-12 brand-downloads-container"
            >
                <div class="scroll-container">
                    <div class="downloads-container grid grid-cols-1 gap-3">
                        <template v-for="(download, dIndex) in tab.downloads">
                            <a
                                v-if="
                                    download.type == 'documentExternal' ||
                                    download.type == 'documentFile'
                                "
                                :href="download.documentLink"
                                class="block text-blue-600 hover:underline text-f5 w-full bg-grey-50 px-4 py-2 rounded-md"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i class="far fa-download mr-2"></i>
                                {{ download.title }}
                            </a>

                            <a
                                v-if="download.type == 'websiteLinkExternal'"
                                :href="download.websiteLink"
                                class="block text-blue-600 hover:underline text-f5 w-full bg-grey-50 px-4 py-2 rounded-md"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i class="far fa-link mr-2"></i>
                                {{ download.title }}
                            </a>

                            <iframe
                                v-if="download.type == 'youtubeVideo'"
                                width="560"
                                height="315"
                                :src="
                                    'https://www.youtube.com/embed/' +
                                    download.youtubeId
                                "
                                :title="download.title"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin"
                                allowfullscreen
                            ></iframe>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
